/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {WebpageState}
 */
export const webpageState = {
    current_guid: undefined,
    current: undefined,
    parent: undefined,
    changeNeeded: false,
    reloadRequired: false,
    saveDisabled: false,
    holdNav: false,
    loading: true,
    settingsUpdateCount: 0,
    publishStatusLoading: false,
    publishStatus: {
        change_type: "none",
        isPublished: false,
        isInMainQueue: false,
        isInReviewQueue: false,
        isModified: false,
        updated_at: null,
        published_at: null,
        publish_state: "draft",
        publishing_queue_state: "not_in_queue",
        review_queue_state: "not_in_queue",
        modified: "unmodified",
        publishChange: undefined,
    },
};


/**
 * @typedef {object} WebpageState
 * @property {Webpage=} current
 * @property {string=} current_guid
 * @property {boolean} changeNeeded
 * @property {boolean} reloadRequired
 * @property {boolean} saveDisabled
 * @property {boolean} holdNav
 * @property {boolean} loading
 * @property {number} settingsUpdateCount
 * @property {import('./webpage.types').PublishStatus} publishStatus Status as returned by the API
 */
